/* Radix-style single-select swatch dropdown behavior for the Material option.
   - Delegated listeners on `document`, so this keeps working even after
     Dawn's variant-selects re-renders the section HTML on option change.
   - Picking a swatch option sets the value on the real (hidden) <select>
     and dispatches a native "change" event, so every existing listener
     (jQuery handlers, Dawn's variant-selects, cart/price logic) keeps
     working exactly as before. No other code needs to change.
*/
(function () {
  function closeAll(except) {
    document.querySelectorAll('[data-swatch-select]').forEach(function (wrap) {
      if (wrap === except) return;
      var trigger = wrap.querySelector('[data-swatch-trigger]');
      var listbox = wrap.querySelector('[data-swatch-listbox]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (listbox) listbox.hidden = true;
    });
  }

  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('.swatchList-close');
    if (closeBtn) {
      var wrap = closeBtn.closest('[data-swatch-select]');
      if (wrap) {
        var triggerEl = wrap.querySelector('[data-swatch-trigger]');
        var listboxEl = wrap.querySelector('[data-swatch-listbox]');
        if (triggerEl) triggerEl.setAttribute('aria-expanded', 'false');
        if (listboxEl) listboxEl.hidden = true;
        if (triggerEl) triggerEl.focus();
      }
      return;
    }

    var trigger = e.target.closest('[data-swatch-trigger]');
    var option = e.target.closest('[data-swatch-option]');
    var wrapClicked = e.target.closest('[data-swatch-select]');

    if (trigger) {
      var wrap = trigger.closest('[data-swatch-select]');
      var listbox = wrap.querySelector('[data-swatch-listbox]');
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';

      closeAll(wrap);

      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      listbox.hidden = isOpen;

      if (!isOpen) {
        var selected = listbox.querySelector('.is-selected') || listbox.querySelector('[data-swatch-option]');
        if (selected) selected.focus();
      }
      return;
    }

    if (option) {
      if (option.getAttribute('aria-disabled') === 'true') return;

      var wrap = option.closest('[data-swatch-select]');
      var select = wrap.querySelector('.swatch-select__native');
      var triggerEl = wrap.querySelector('[data-swatch-trigger]');
      var listboxEl = wrap.querySelector('[data-swatch-listbox]');
      var swatchEl = triggerEl.querySelector('[data-swatch-trigger-swatch]');
      var labelEl = triggerEl.querySelector('[data-swatch-trigger-label]');

      var value = option.getAttribute('data-value');
      var label = option.getAttribute('data-label') || value;
      var optionSwatch = option.querySelector('.swatch-select__swatch');

      // Update the real select + fire a native change event so every
      // existing handler (jQuery, Dawn's variant-selects, price logic)
      // still runs exactly like it did with the plain <select>.
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));

      // Reflect the pick in the closed trigger.
      if (labelEl) labelEl.textContent = label;
      if (swatchEl && optionSwatch) {
        swatchEl.setAttribute('style', optionSwatch.getAttribute('style') || '');
      }

      // Update selected state in the list.
      listboxEl.querySelectorAll('[data-swatch-option]').forEach(function (li) {
        li.classList.remove('is-selected');
        li.setAttribute('aria-selected', 'false');
      });
      option.classList.add('is-selected');
      option.setAttribute('aria-selected', 'true');

      // Close instantly, as requested.
      triggerEl.setAttribute('aria-expanded', 'false');
      listboxEl.hidden = true;
      triggerEl.focus();
      return;
    }

    if (!wrapClicked) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAll();
      return;
    }

    var option = e.target.closest('[data-swatch-option]');
    if (!option) return;

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      option.click();
      return;
    }

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      var listbox = option.closest('[data-swatch-listbox]');
      var items = Array.prototype.slice.call(listbox.querySelectorAll('[data-swatch-option]'));
      var idx = items.indexOf(option);
      var next = e.key === 'ArrowDown' ? items[idx + 1] : items[idx - 1];
      if (next) next.focus();
    }
  });
})();